// ════════════════════════════════════════════════════════════════════
// LYRAEA — CDN.  One file. One domain. One truth.
// ────────────────────────────────────────────────────────────────────
// THE CRITICAL TRAP, restated because it will bite here harder than
// anywhere else in the Empire:
//
//   THE APP DOMAIN IS NOT THE ASSET DOMAIN.
//
// lyraea.pages.dev is a React SPA with catch-all routing — it serves
// index.html for EVERY path. A malformed asset URL pointed at it does
// NOT 404. It returns an HTML document with a 200, and you will chase
// the wrong bug for an hour. With audio it is worse than with images:
// an <audio> element handed HTML fails with a bare, uninformative
// MEDIA_ERR_SRC_NOT_SUPPORTED and no hint that the URL was the problem.
//
//   FIRST QUESTION when a track will not play: is this URL pointed at
//   the app domain or the asset domain? Answer that before anything else.
//
// Audio and cover art live on lyraea-assets.pages.dev, a SEPARATE
// Cloudflare Pages project, flat, from day one. Never "just for now" on
// the app project.
//
// ── SCALE NOTE, honestly stated ──────────────────────────────────────
// Cloudflare Pages caps a single file at 25 MB and a project at 20,000
// files. For caP'n's own catalogue that is comfortable — a 5-minute MP3
// at 192kbps is ~7 MB. It is NOT the shape for a library of strangers'
// uploads, and it is not pretending to be. When uploads open to other
// people this constant moves to R2 or Bunny and NOTHING ELSE IN THE
// CODEBASE CHANGES — which is the entire reason it is one line here.
// ════════════════════════════════════════════════════════════════════

export const CDN = "https://lyraea-assets.pages.dev";

// Audio. Pass the stored filename, e.g. "the_rise.mp3".
export const trackUrl = (file) => (file ? `${CDN}/${file}` : "");

// Cover art. WebP, converted on the way in, never at runtime.
export const coverUrl = (file) => (file ? `${CDN}/${file}` : "");

// A cover may also be stored as a full URL (art already hosted elsewhere
// in the Empire, e.g. a Terror card). Resolve either shape, one function,
// so no call site ever has to know which it got.
export const resolveCover = (v) => {
  if (!v) return "";
  return /^https?:\/\//i.test(v) ? v : coverUrl(v);
};

export const resolveTrack = (v) => {
  if (!v) return "";
  // blob: = an audiobook dropped from the listener's own device (book.js).
  // It must pass through untouched — prefixing the CDN would break it.
  return /^(https?:\/\/|blob:)/i.test(v) ? v : trackUrl(v);
};
